import React, { useEffect, useState } from "react";

const OPTIONS = [
    { label: "24 hours", value: "24h" },
    { label: "7 days", value: "7d" },
    { label: "30 days", value: "30d" },
];

interface PinDurationModalProps {
    visible: boolean;
    onClose: () => void;
    onConfirm: (duration: string) => void;
}

const PinDurationModal = ({ visible, onClose, onConfirm }: PinDurationModalProps) => {
    const [selected, setSelected] = useState("24h");

    useEffect(() => {
        if (visible) setSelected("24h");
    }, [visible]);

    if (!visible) return null;

    return (
        <div
            className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40"
            onClick={onClose}
        >
            <div
                className="w-[360px] bg-[#F9FBFE] rounded-[16px] p-4 shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)]"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start justify-between gap-2 mb-1">
                    <h3 className="out-500-14 text-[#292927]">Pin Message</h3>
                    <button
                        onClick={onClose}
                        className="w-6 h-6 flex items-center justify-center rounded-full text-gray-700 hover:bg-gray-100 hover:text-gray-600 flex-shrink-0"
                    >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>

                <p className="out-300-14 text-gray-500 mb-3">
                    Select how long your pinned message stays. You can un-pin it anytime.
                </p>

                <div className="flex flex-col">
                    {OPTIONS.map((opt) => (
                        <label
                            key={opt.value}
                            className="flex items-center gap-2 py-1.5 cursor-pointer select-none"
                            onClick={() => setSelected(opt.value)}
                        >
                            <span className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                                <span
                                    className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === opt.value ? "border-primary-600" : "border-gray-300"
                                        }`}
                                >
                                    {selected === opt.value && <span className="w-2.5 h-2.5 rounded-full bg-primary-600" />}
                                </span>
                            </span>
                            <span className="out-500-14 text-gray-900">{opt.label}</span>
                        </label>
                    ))}
                </div>

                <div className="flex items-center justify-end gap-4 mt-3">
                    <button onClick={onClose} className="out-500-14 text-primary-600 px-2 py-2">
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(selected)}
                        className="out-500-14 text-white bg-primary-600 hover:bg-[#194185] border border-primary-600 rounded-[4px] px-[10px] py-[5px]"
                    >
                        Pin
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PinDurationModal;